"use client";

import React from "react";
import AspectRatio from "@/components/layout/AspectRatio";
import Carousel from "@/components/media/Carousel";
import Headline from "@/components/project/Headline";
import { useViewport } from "@/components/providers/ViewportProvider";
import Typography from "@/components/shared/Typography";
import Visibility from "@/components/shared/Visibility";
import Button from "@/components/ui/Button";
import Card from "@/components/ui/Card";
import { HREF_PHONE_NUMBER, URLS } from "@/lib/consts";
import { cn } from "@/lib/utils";
import type { GalleryContactUsItemProps } from "../types";

function GalleryContactUsItem({
  index,
  showAction = true,
  presetRatio = "tall",
  className,
  sm,
  md = "md:basis-1/2",
  lg = "lg:basis-1/3",
  ...props
}: GalleryContactUsItemProps) {
  const { isMobileMode } = useViewport();

  return (
    <Carousel.Item
      data-slot="gallery-contact-us-item"
      forceMount
      index={index}
      sm={sm}
      md={md}
      lg={lg}
      className={cn("basis-full h-fit min-h-[300px]", className)}
      {...props}
    >
      <AspectRatio presetRatio={presetRatio}>
        <Card
          variant="secondary"
          className={cn("w-full h-full rounded-sm", className)}
        >
          <Card.Header fill={true} justify="center">
            <Headline as="H3" className="text-primary">
              Stop Stressing
            </Headline>
            <Typography.H4 className="text-foreground-secondary">
              Get Answers Today.
            </Typography.H4>
          </Card.Header>

          <Card.Content justify="end">
            <Visibility shouldShow={isMobileMode || showAction}>
              <Button.Icon
                icon="phone-call"
                variant="default"
                href={isMobileMode ? HREF_PHONE_NUMBER : URLS.CONTACT_US}
                aria-label={isMobileMode ? "Call us" : "Goto Contact Us page"}
              />
            </Visibility>
          </Card.Content>
        </Card>
      </AspectRatio>
    </Carousel.Item>
  );
}

GalleryContactUsItem.displayName = "Gallery.ContactUsItem";

export default GalleryContactUsItem;
